import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { ReportedUserManagement } from '../modal';

export default function reducer(state: ReportedUserManagement = new ReportedUserManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.REPORTED_USER_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.REPORTED_USER_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.REPORTED_USER_MGMT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
